import React, { useEffect, useState } from 'react';
import { AdminDocumentTypesService, AdminDocumentType } from '../services/admin-document-types.service';
import { useNotification } from '../context/NotificationContext';
import styles from './AdminDocumentTypesPage.module.css';

export default function AdminDocumentTypesPage() {
  const { addNotification } = useNotification();
  const [items, setItems] = useState<AdminDocumentType[]>([]);
  const [loading, setLoading] = useState(true);
  const [code, setCode] = useState('');
  const [label, setLabel] = useState('');

  const load = async () => {
    setLoading(true);
    try {
      const res = await AdminDocumentTypesService.list();
      const list = (res as any)?.data;
      setItems(Array.isArray(list) ? list : []);
    } catch (error: any) {
      addNotification(error?.message || 'Error cargando tipos', 'error');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    load();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onCreate = async () => {
    if (!code.trim() || !label.trim()) return;
    try {
      await AdminDocumentTypesService.create({ code: code.trim(), label: label.trim() });
      setCode('');
      setLabel('');
      addNotification('Tipo creado.', 'success');
      await load();
    } catch (error: any) {
      addNotification(error?.message || 'Error creando tipo', 'error');
    }
  };

  const onToggle = async (id: number, is_active: boolean) => {
    try {
      await AdminDocumentTypesService.update(id, { is_active: !is_active });
      await load();
    } catch (error: any) {
      addNotification(error?.message || 'Error actualizando tipo', 'error');
    }
  };

  return (
    <div className={styles.page}>
      <header className={styles.header}>
        <div>
          <h1 className={styles.title}>Tipos de documentos</h1>
          <p className={styles.subtitle}>Administra el catálogo visible para los desarrolladores.</p>
        </div>
      </header>

      <section className={styles.card}>
        <h3 className={styles.cardTitle}>Crear tipo</h3>
        <div className={styles.form}>
          <input className={styles.input} value={code} onChange={e => setCode(e.target.value)} placeholder="CODE" />
          <input className={styles.input} value={label} onChange={e => setLabel(e.target.value)} placeholder="Etiqueta" />
          <button type="button" className={styles.primary} onClick={onCreate}>Crear</button>
        </div>
      </section>

      <section className={styles.card}>
        <h3 className={styles.cardTitle}>Lista</h3>
        {loading ? (
          <div>Cargando...</div>
        ) : (
          <div className={styles.list}>
            {items.map((it) => (
              <div key={it.id} className={styles.row}>
                <div>
                  <strong>{it.label}</strong> <span className={styles.muted}>({it.code})</span>
                </div>
                <button type="button" className={styles.ghost} onClick={() => onToggle(it.id, it.is_active)}>
                  {it.is_active ? 'Desactivar' : 'Activar'}
                </button>
              </div>
            ))}
          </div>
        )}
      </section>
    </div>
  );
}
